<template>
  <section id="hero" class="has-text-white">
    <div class="columns is-vcentered">
      <div class="column is-two-fifths is-offset-three-fifths">
        <p class="is-size-3 is-uppercase">Searching a<br> web developer?<br>STOP!<br>Here I am.</p>
        <h1 class="is-uppercase">I'm the<br> bearded<br>
        <typewriter
          :speed="100"
          :full-erase="false"
          :interval="300"
          :words='typeWriterWords'>
        </typewriter>
        <br> next door.</h1>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: 'Hero',
  data: function () {
    const typeWriterSpacing = "        "
    return {
      typeWriterWords: [`web developer${typeWriterSpacing}`,
        `nerd${typeWriterSpacing}`,
        `web developer${typeWriterSpacing}`,
        `good guy${typeWriterSpacing}`,
        `web developer${typeWriterSpacing}`,
        `viking${typeWriterSpacing}`,
        `web developer${typeWriterSpacing}`,
        `geek${typeWriterSpacing}`,
        `web developer${typeWriterSpacing}`,
        `programmer${typeWriterSpacing}`,
        `superhero${typeWriterSpacing}`,
        `coder${typeWriterSpacing}`]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/mixins";

section#hero{
  min-height: 100vh;
  //height: calc(100vh-$navbar-height); //ToDo: variable müsste verfügbar gemacht werden
  background-image: linear-gradient(rgba(0,0,0, .1), rgba(0,0,0, .1)), url("../assets/hero.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  font-family: 'Fjalla One', sans-serif;

  div.columns{
    min-height: inherit;//BugFix: Without this, the childs of "min-height" won't get the height.

    div.column {
      background-image: linear-gradient(rgba($colorMain, .7), rgba($colorMain, .7));
      min-height: inherit;//BugFix: Without this, the childs of "min-height" won't get the height.
      text-align: left;

      display: flex;
      flex-direction: column;
      justify-content: space-evenly
    }
  }

  h1{
    padding-top: 1rem;
    @include mobile {
      font-size: 3rem;
    }
    @include from($tablet) {
      font-size: 3rem;
    }
    @include from($desktop) {
      font-size: 3.5rem;
    }
    @include from($widescreen) {
      font-size: 4rem;
    }
    @include from(1550px) {
      font-size: 5rem;
    }
  }
}
</style>